import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestJobResultPost = {
    path: "/job/:id/result",
    method: RouteHttpVerb.POST
};
